"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Popover_1 = require("../Popover");
var StyledPopoverBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  ", ";\n  font-size: 0.875rem;\n\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n  ", ";\n  font-size: 0.875rem;\n\n  ",
    ";\n"])), style_utils_1.getColor("gray", 900), style_utils_1.setPadding("x", 3), style_utils_1.setPadding("y", 1), function (props) {
    return props.$rtl && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      direction: rtl;\n      text-align: right;\n    "], ["\n      direction: rtl;\n      text-align: right;\n    "])));
});
var PopoverBody = react_1.default.forwardRef(function (props, ref) {
    var rtl = react_1.default.useContext(Popover_1.PopoverContext).rtl;
    return react_1.default.createElement(StyledPopoverBody, __assign({}, props, { ref: ref, "$rtl": rtl }));
});
PopoverBody.displayName = "PopoverBody";
exports.default = PopoverBody;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map